<template>
  <Layout>
    <div :class="$style.basicPlan">
      <div class="container">
        <div class="dingbeauty-banner-content ">
          <p class="sub-title">Basic Plan</p>
          <h1 class="title">初階方案</h1>
          <div class="description">
            <p>美業之路新起點！</p>
            <p>專為獨立工作室設計，輕鬆擁有自己的預約管理系統！</p>
            <p>無需高額花費，即可滿足您所有的功能需求，</p>
            <p>讓您專心打造美麗，不再煩惱管理。</p>
          </div>
        </div>
      </div>
    </div>
    <SectionFeatures></SectionFeatures>
    <SectionBeAhead></SectionBeAhead>
    <SectionFunctions></SectionFunctions>
    <DingBeautyHelp :isFade="true"></DingBeautyHelp>
  </Layout>
</template>

<script>
import Layout from '@layout/main'
import SectionFeatures from './components/SectionFeatures'
import DingBeautyHelp from '@src/components/DingBeauty/DingBeautyHelp.vue'
import SectionBeAhead from './components/SectionBeAhead'
import SectionFunctions from './components/SectionFunctions'

export default {
  page() {
    return {
      title: '方案價格',
    }
  },
  components: {
    Layout,
    SectionFeatures,
    DingBeautyHelp,
    SectionBeAhead,
    SectionFunctions,
  },
}
</script>

<style lang="scss" module>
.basicPlan {
  position: relative;
  background-image: url('@assets/images/home/banner032.jpg');
  height: 100vh;
  background-size: cover;
  background-position: 56% center;

  // Darken background
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    background-color: rgba($color: #000000, $alpha: 0.2);
    width: 100%;
    height: 100%;
  }
}

@media (min-width: 992px) {
  .basicPlan {
    height: 700px;
    background-position: center;
  }
}
</style>
